module.exports = __webpack_public_path__ + "static/img/man.ee8c5a60.png";